export class AccessibleOrganizationAccount {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "domain",
            "baseName": "domain",
            "type": "string",
            "format": ""
        },
        {
            "name": "roles",
            "baseName": "roles",
            "type": "Array<OrganizationAccountRole>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AccessibleOrganizationAccount.attributeTypeMap;
    }
    constructor() {
    }
}
